import React from "react";
import {
  Card,
  Typography,
  Button,
  Space,
  notification,
  Tabs,
  Pagination,
  Spin,
  Tooltip,
  Modal,
  Input,
  Alert,
  Table,
} from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import mainContext from "../context/MainContext/mainContext";
import GenerateSubInvoice from "./GenerateSubInvoice";
import { FaInbox } from "react-icons/fa";
import CreditNote from "./CreditNote";
import GeneratedCreditNotes from "./GeneratedCreditNotes";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { computeInvoiceSubtotal } from "../../../../../utils/billingInvMatch";
import { openFileInNewTab } from "../../../../../utils/convertS3ToCloudFront";

const { Text } = Typography;
const { TabPane } = Tabs;
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const formatAckDate = (ackDate) => {
  if (!ackDate) return "";
  const m = moment(
    ackDate,
    ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss", moment.ISO_8601],
    true
  );
  return m.isValid() ? m.format("DD-MM-YY, hh:mm A") : ackDate;
};

const formatInvoiceDate = (ackDate) => {
  if (!ackDate) return "—";
  const m = moment(
    ackDate,
    ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss", moment.ISO_8601],
    true
  );
  return m.isValid() ? m.format("DD-MM-YYYY") : "—";
};

function is48HoursPassed(dateTimeString) {
  if (!dateTimeString) return false;
  const inputDate = new Date(String(dateTimeString).replace(" ", "T"));
  const currentDate = new Date();
  const diffInMs = currentDate - inputDate;
  const hoursPassed = diffInMs / (1000 * 60 * 60);
  return hoursPassed > 48;
}

const Einvoices = ({ setParentTab }) => {
  const navigate = useNavigate();
  const {
    generateEInvoice,
    getIrnDetails,
    cancelInvoice,
    cancelBillingInvoice,
    remark,
    setRemark,
  } = useContext(mainContext);
  const SignedQRCode =
    "eyJhbGciOiJSUzI1NiIsImtpZCI6IjRERTE1NDRBRTY5NUJEQzg0RUM3QkMxMkYyRjU3RjgxM0Y0NEUzMDEiLCJ4NXQiOiJUZUZVU3VhVnZjaE94N3dTOHZWX2dUOUU0d0UiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJOSUMiLCJkYXRhIjoie1wiU2VsbGVyR3N0aW5cIjpcIjI0QUFERlkwMDc3RTFaRVwiLFwiQnV5ZXJHc3RpblwiOlwiMjNBQUxDUDE0NTJCMVpXXCIsXCJEb2NOb1wiOlwiR0otMjI3OC1NQVIyNFwiLFwiRG9jVHlwXCI6XCJJTlZcIixcIkRvY0R0XCI6XCIyOC8wMy8yMDI1XCIsXCJUb3RJbnZWYWxcIjo1NDUxNjAuMCxcIkl0ZW1DbnRcIjoxLFwiTWFpbkhzbkNvZGVcIjpcIjk5ODM2MVwiLFwiSXJuXCI6XCJmODFiYTYxNThiOTRiYzM1ODlhMjg0YzAyYTQ3ZmMwMmYwNGQ1ZTkzYmQ2MzM5MmI1NmVhMzVlNmU2M2NkZDVlXCIsXCJJcm5EdFwiOlwiMjAyNS0wMy0yOCAxNDo1ODowMFwifSJ9.GZkbJmgrcAYIFgPAMqgu7hcizOz9yGJnJsttvAmN6eCWmD51nj9AVASgvC0Zx67OBXZH2M972x1MBNLBJKzyH69nUKpPGKJtXXt-CNsCcLppAqa1DrsbP7gvBMkvlrK9scoAp2hxykZitBCy-0YgCgLalj1N5jo_Ql5-kHvQpc5PVMXOOaSw889BQTS2EgSbzcbWfB-8MZ1SfPVKXnAOgLJxiMAMJyMLfPWRMSNqMHp_rAmSm7_CtQS8E5201Y7zBA1L_GCOK__nREHvpQfJRieSuCjOikN1NFCLJEirdy01vePFMV0JjZWHN5GzCVUXeg79liuimVfImrp-zW34kg";
  const {
    getAllSubInvoice,
    setInvoiceData,
    invoiceData,
    allSubInvoices,
    pageNumber,
    pageSize,
    setPageNumber,
    setPageSize,
    loading,
    totalSubInvoices,
  } = useContext(mainContext);
  const [subTotal, setSubTotal] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [invData, setInvData] = useState(null);
  const [isCreditNoteModalOpen, setIsCreditNoteModalOpen] = useState(false);
  const [creditNoteInvoiceData, setCreditNoteInvoiceData] = useState(null);
  const [isCancelInvoiceModalVisible, setIsCancelInvoiceModalVisible] =
    useState(false);
  const [cancelTargetInvoiceId, setCancelTargetInvoiceId] = useState(null);
  const [cancelSnapshot, setCancelSnapshot] = useState(null);
  const [isCancellingInvoice, setIsCancellingInvoice] = useState(false);

  useEffect(() => {
    getAllSubInvoice();
  }, [getAllSubInvoice]);

  useEffect(() => {
    const totalPages = Math.ceil(
      (totalSubInvoices || 0) / (pageSize || 1)
    );
    const safeTotalPages = totalPages > 0 ? totalPages : 1;
    if (pageNumber > safeTotalPages) {
      setPageNumber(safeTotalPages);
    }
  }, [
    totalSubInvoices,
    pageSize,
    pageNumber,
    setPageNumber,
  ]);

  const handleInvPageChange = (page, size) => {
    setPageNumber(page);
    setPageSize(size);
  };

  // console.log("allSubInvoices:::", allSubInvoices);

  useEffect(() => {
    if (creditNoteInvoiceData) {
      setIsCreditNoteModalOpen(true);
    }
  }, [creditNoteInvoiceData]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setInvData(null); // Clear data when modal closes
  };

  const fetchInvoiceDataByID = async (invoiceId) => {
    try {
      if (!invoiceId) return null;

      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getInvoiceDataById?invoiceId=${invoiceId}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();

      if (!response.ok) {
        notification.error({
          message: responseData?.message || "Failed to fetch the sales order",
        });
        return null;
      }
      // console.log("this is the responseData v", responseData);

      // console.log("responseData ::: partyCompany", responseData?.invoiceInfo?.billingId?.partyCompany?.name);

      const invoiceInfo = responseData.invoiceInfo.salesOrderId || {};
      const bdfId = invoiceInfo?.bdfId || {};
      const brandId = bdfId?.brandId || {};
      const rootParty = responseData?.invoiceInfo?.party || {};
      const rootBrand = responseData?.invoiceInfo?.brand || {};
      const billingPartyCompany =
        responseData?.invoiceInfo?.billingId?.partyCompany || {};
      const partyCompany = bdfId?.parentCompanyId || {};
      const billedInvs = responseData.invoiceInfo?.inventories || [];
      const infoForCN = responseData?.invoiceInfo?.infoForCN || [];
      const billedSuffixInvs =
        responseData.invoiceInfo?.suffixInventories || [];
      // console.log("this is the calling PIS", responseData.invoiceInfo);

      const invoiceData = {
        AckNo: responseData?.invoiceInfo?.AckNo,
        AckDate: responseData?.invoiceInfo?.AckDate,
        SignedInvoice: responseData?.invoiceInfo?.SignedInvoice,
        SignedQRCode: responseData?.invoiceInfo?.SignedQrCode,
        IRN: responseData?.invoiceInfo?.IRN,
        isRejected: responseData?.invoiceInfo?.isRejected,
        cancelReason: responseData?.invoiceInfo?.cancelremark,
        bdfId: bdfId?._id,
        salesPerson: bdfId?.salesPerson,
        bdfStamp: bdfId?.stamp,
        partyName: rootParty?.name || null,
        partyGstNumber: rootParty?.gstNumber || null,
        partyPanNumber:
          rootParty?.panNumber ||
          billingPartyCompany?.panNumber ||
          partyCompany?.panNumber ||
          bdfId?.parentCompanyId?.panNumber ||
          bdfId?.brandId?.partyCompany?.panNumber ||
          null,
        partyState:
          rootParty?.state ||
          billingPartyCompany?.state ||
          partyCompany?.state ||
          bdfId?.parentCompanyId?.state ||
          bdfId?.brandId?.partyCompany?.state ||
          null,
        partyAddress: rootParty?.address || null,
        partyAdd1: rootParty?.add1 ?? null,
        partyAdd2: rootParty?.add2 ?? null,
        partyAdd3: rootParty?.add3 ?? null,
        partyCity: rootParty?.city ?? null,
        partyPinCode: rootParty?.pinCode ?? null,
        gstNumber:
          rootParty?.gstNumber ||
          billingPartyCompany?.gstNumber ||
          partyCompany?.gstNumber ||
          bdfId?.parentCompanyId?.gstNumber ||
          bdfId?.brandId?.partyCompany?.gstNumber ||
          null,
        state:
          rootParty?.state ||
          billingPartyCompany?.state ||
          partyCompany?.state ||
          bdfId?.parentCompanyId?.state ||
          bdfId?.brandId?.partyCompany?.state ||
          null,
        panNumber:
          rootParty?.panNumber ||
          billingPartyCompany?.panNumber ||
          partyCompany?.panNumber ||
          bdfId?.parentCompanyId?.panNumber ||
          bdfId?.brandId?.partyCompany?.panNumber ||
          null,
        isB2C: responseData?.invoiceInfo?.isB2C === true,
        aliasPartyName: responseData?.invoiceInfo?.aliasPartyName || null,
        splitParentCompanyName: billingPartyCompany?.name || null,
        splitGSTNumber: billingPartyCompany?.gstNumber || null,
        splitParentCompanyAddress: billingPartyCompany?.address || null,
        parentCompanyAddress:
          billingPartyCompany?.address || partyCompany?.address || null,
        parentAdd1: partyCompany?.add1 ?? null,
        parentAdd2: partyCompany?.add2 ?? null,
        parentAdd3: partyCompany?.add3 ?? null,
        parentCity: partyCompany?.city ?? null,
        parentPinCode: partyCompany?.pinCode ?? null,
        splitAdd1: billingPartyCompany?.add1 ?? null,
        splitAdd2: billingPartyCompany?.add2 ?? null,
        splitAdd3: billingPartyCompany?.add3 ?? null,
        splitCity: billingPartyCompany?.city ?? null,
        splitPinCode: billingPartyCompany?.pinCode ?? null,
        stamp: invoiceInfo.stamp || null,
        roNumber: invoiceInfo.roNumber || null,
        parentCompanyName:
          billingPartyCompany?.name ||
          bdfId?.parentCompanyId?.name ||
          bdfId?.parentCompanyName ||
          partyCompany?.name ||
          bdfId?.brandId?.partyCompany?.name ||
          null,
        remark: bdfId?.remark || null,
        invoiceRemark:
          responseData?.invoiceInfo?.remark ||
          responseData?.invoiceInfo?.invoiceRemark ||
          null,
        invoiceSubRemark:
          responseData?.invoiceInfo?.subRemark ||
          responseData?.invoiceInfo?.invoiceSubRemark ||
          null,
        brandName:
          rootBrand?.brandName ||
          responseData?.invoiceInfo?.brandName ||
          brandId?.brandName ||
          null,
        campaignName: responseData?.invoiceInfo?.campaignName || bdfId?.campaignName || null,
        agencyCommission: invoiceInfo?.agencyCommission || 0,
        campaignDuration: bdfId?.campaignDuration || null,
        bdfCreatorName: bdfId?.createdBy?.name,
        bdfCreatorId: bdfId?.createdBy?._id,
        bdfType: bdfId?.bdfType,
        printingCharge: responseData?.invoiceInfo?.printingCharge || 0,
        mountingCharge: responseData?.invoiceInfo?.mountingCharge || 0,
        createdAt: responseData?.invoiceInfo?.createdAt,
        billedSuffixInvs,
        billedInvs: billedInvs.map((inv) => ({
          _id: inv?.invId?._id || null,
          amount: inv?.amount || null,
          startDate: inv?.startDate || null,
          endDate: inv?.endDate || null,
          height: inv?.invId?.height || null,
          width: inv?.invId?.width || null,
          locationName: inv?.invId?.locations?.name || null,
          CodeNo: inv?.invId?.CodeNo || null,
          unit: inv?.invId?.unit || null,
          isTrading: inv?.invId?.isTrading || false,
          ownedBy: inv?.invId?.ownedBy || null,
        })),
        infoForCN: infoForCN?.inventoryAgainst?.map((inv) => ({
          _id: inv?.invId?._id || null,
          amount: inv?.amount || null,
          startDate: inv?.startDate || null,
          endDate: inv?.endDate || null,
          height: inv?.invId?.height || null,
          width: inv?.invId?.width || null,
          locationName: inv?.invId?.locations?.name || null,
          CodeNo: inv?.invId?.CodeNo || null,
          unit: inv?.invId?.unit || null,
          isTrading: inv?.invId?.isTrading || false,
          ownedBy: inv?.invId?.ownedBy || null,
          amount: inv?.amount || null,
        })),
        infoForCNSummery: infoForCN || [],
        taxType: invoiceInfo?.taxType || 0,
        IGST: responseData.invoiceInfo?.IGST || 0,
        SGST: responseData.invoiceInfo?.SGST || 0,
        CGST: responseData.invoiceInfo?.CGST || 0,
        municipalTax: invoiceInfo?.municipalTax || 0,
        otherTaxes: invoiceInfo?.otherTaxes || 0,
        round: invoiceInfo?.round || 0,
        isFromSub: Boolean(invoiceInfo?.isFromSub),
        HSN: responseData?.invoiceInfo?.HSN,
        invoiceId: responseData?.invoiceInfo?._id,
        billNumber: responseData?.invoiceInfo?.billNumber,
        refNo: responseData?.invoiceInfo?.refNo ?? null,
        refDate: responseData?.invoiceInfo?.refDate ?? null,
        bdfDate: responseData?.invoiceInfo?.salesOrderId?.bdfId?.bdfDate ?? null,
      };
      // console.log("invoiceDataaaa", invoiceData);
      setInvoiceData(invoiceData);
      setSubTotal(
        computeInvoiceSubtotal({
          billedInvs,
          billedSuffixInvs,
          bdfInventories: bdfId?.inventories,
          printingCharge: responseData?.invoiceInfo?.printingCharge,
          mountingCharge: responseData?.invoiceInfo?.mountingCharge,
        }),
      );
      // console.log("oioioio", invoiceData);
      return invoiceData; // ✅ Make sure to return data
    } catch (error) {
      notification.error({
        message: error.message,
      });
      return null; // Return null in case of an error
    }
  };

  const handleEInvoice = async (invoiceId) => {
    console.log("iddddd", invoiceId);
    const data = await fetchInvoiceDataByID(invoiceId);
    if (data) {
      setInvData(data); // ✅ Ensure data exists before updating state
      setIsModalOpen(true);
    }
  };

  const handleOpenCreditNoteModal = async (invoiceId) => {
    const data = await fetchInvoiceDataByID(invoiceId);
    if (!data) return;
    try {
      const cnResponse = await fetch(
        `${apiBaseUrl}/inventoryManagement/returnNextCNNumber`,
        {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        }
      );
      const cnResult = await cnResponse.json();
      const cnNumber = cnResult?.success && cnResult?.data?.cnNumber
        ? cnResult.data.cnNumber
        : null;
      setCreditNoteInvoiceData({ ...data, cnNumber });
    } catch (err) {
      console.error("Failed to fetch next CN number:", err);
      notification.error({
        message: "Failed to load Credit Note number",
        description: err?.message || "Could not fetch next CN number",
      });
      setCreditNoteInvoiceData(null);
    }
  };

  const handleCloseCreditNoteModal = () => {
    setIsCreditNoteModalOpen(false);
    setCreditNoteInvoiceData(null);
  };

  const handleGenerateCreditNote = (amount) => {
    setIsCreditNoteModalOpen(false);
    setCreditNoteInvoiceData(null);
    // notification.success({ message: `Credit note for ₹${totalInventoryAmount} generated!` });
    navigate("/billing?tab=5");
    setParentTab("5");
  };

  const openCancelInvoiceModal = (item) => {
    setRemark("");
    setCancelTargetInvoiceId(item._id);
    setCancelSnapshot({
      IRN: item.IRN,
      AckDate: item.AckDate,
      isB2C: item.isB2C === true,
    });
    setIsCancelInvoiceModalVisible(true);
  };

  const closeCancelInvoiceModal = () => {
    if (isCancellingInvoice) {
      return;
    }
    setIsCancelInvoiceModalVisible(false);
    setRemark("");
    setCancelTargetInvoiceId(null);
    setCancelSnapshot(null);
  };

  const handleConfirmCancelInvoice = async () => {
    if (
      !remark.trim() ||
      isCancellingInvoice ||
      !cancelTargetInvoiceId ||
      !cancelSnapshot
    ) {
      return;
    }
    setIsCancellingInvoice(true);
    try {
      if (!cancelSnapshot.IRN || is48HoursPassed(cancelSnapshot.AckDate)) {
        await cancelBillingInvoice(cancelTargetInvoiceId, remark);
        closeCancelInvoiceModal();
        return;
      }
      const isCancelled = await cancelInvoice(cancelSnapshot.IRN);
      if (isCancelled) {
        const reqBody = {
          remark,
          IRN: cancelSnapshot.IRN,
        };
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/cancelInvoice`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(reqBody),
          }
        );
        const data = await response.json();
        if (data.success == true) {
          await cancelBillingInvoice(cancelTargetInvoiceId, remark);
        }
      }
      closeCancelInvoiceModal();
    } finally {
      setIsCancellingInvoice(false);
    }
  };

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  return (
    <div className="salesOrder-tab-list">
      <div className="salesOrder-list-container">
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <style>{`
            /* Highlight cancelled rows similar to previous card UI */
            .ant-table-row.einvoice-row--cancelled > td {
              background: #ffcccc !important;
            }
            /* Avoid positioning on <tr> (table-row) as it can affect layout in some browsers */
            .ant-table-row.einvoice-row--cancelled > td:nth-child(4) {
              position: relative;
            }
            .ant-table-row.einvoice-row--cancelled > td:nth-child(4)::after {
              content: "CANCELLED";
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              font-size: 48px;
              font-weight: 800;
              color: rgba(255, 0, 0, 0.12);
              white-space: nowrap;
              pointer-events: none;
              z-index: 1;
            }
            /* Light alert background for credit note alert rows */
            .ant-table-row.einvoice-row--credit-alert > td {
              background: #fff0f0 !important;
            }

            /* Ensure table uses full available width consistently */
            .einvoice-table,
            .einvoice-table .ant-table,
            .einvoice-table .ant-table-container {
              width: 100%;
            }
          `}</style>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Spin size="large" />
            </div>
          ) : !totalSubInvoices ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                justifyContent: "center",
                fontSize: "1.5rem",
                fontWeight: "600",
                color: "gray",
                marginBottom: "1rem",
              }}
            >
              <FaInbox /> No E-Invoices yet!
            </div>
          ) : (
            <Table
              components={components}
              className="einvoice-table"
              style={{ width: "100%" }}
              rowKey={(record) => record?._id}
              tableLayout="auto"
              pagination={false}
              dataSource={allSubInvoices || []}
              rowClassName={(record) =>
                record?.isRejected
                  ? "einvoice-row--cancelled"
                  : record?.creditNoteAlert
                    ? "einvoice-row--credit-alert"
                    : ""
              }
              columns={[
                {
                  title: "Invoice Date",
                  key: "invoiceDate",
                  width: 110,
                  align: "center",
                  render: (_, record) => (
                    <span>
                      {formatInvoiceDate(
                        record?.invoiceDate ||
                          record?.AckDate ||
                          record?.createdAt,
                      )}
                    </span>
                  ),
                },
                {
                  title: "Bill Number",
                  dataIndex: "billNumber",
                  key: "billNumber",
                  width: 180,
                  align: "center",
                  render: (v) => v ?? "Not available",
                },
                {
                  title: "Party Name",
                  key: "partyName",
                  width: 240,
                  align: "center",
                  render: (_, record) => (
                    <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                      {record?.party?.name ||
                        record?.billingId?.partyCompany?.name ||
                        record?.salesOrderId?.bdfId?.partyName ||
                        "Not available"}
                    </div>
                  ),
                },
                {
                  title: "Campaign Name",
                  key: "campaignName",
                  width: 240,
                  align: "center",
                  render: (_, record) => (
                    <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                      {record?.campaignName ||
                        record?.salesOrderId?.bdfId?.campaignName ||
                        "Not available"}
                    </div>
                  ),
                },
                {
                  title: "Brand Name",
                  key: "brandName",
                  width: 200,
                  align: "center",
                  render: (_, record) => (
                    <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                      {record?.brand?.brandName ||
                        record?.brandName ||
                        record?.salesOrderId?.bdfId?.brandName ||
                        "Not available"}
                    </div>
                  ),
                },
                {
                  title: "SO Number",
                  key: "soNumber",
                  width: 140,
                  align: "center",
                  render: (_, record) =>
                    record?.salesOrderId?.stamp ?? "Not available",
                },
                {
                  title: "Total Amount",
                  dataIndex: "totalAmount",
                  key: "totalAmount",
                  width: 130,
                  align: "center",
                  render: (_, record) => {
                    const raw = record?.totalAmount;
                    if (raw == null || raw === "") return "—";
                    const base = Number(raw);
                    if (Number.isNaN(base)) return "—";
                    const roundOff = Number(record?.roundOff ?? 0);
                    const afterRoundOff =
                      base + (Number.isNaN(roundOff) ? 0 : roundOff);
                    const wholeRupees = Math.round(afterRoundOff);
                    return `₹${wholeRupees.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`;
                  },
                },
                {
                  title: "RO",
                  key: "ro",
                  width: 80,
                  align: "center",
                  render: (_, record) => {
                    const roFile = record?.salesOrderId?.bdfId?.roFile;
                    if (!roFile) return "—";
                    return (
                      <Button
                        type="link"
                        size="small"
                        style={{ padding: 0 }}
                        onClick={() => openFileInNewTab(roFile)}
                      >
                        View
                      </Button>
                    );
                  },
                },
                {
                  title: "Actions",
                  key: "actions",
                  width: 260,
                  align: "center",
                  render: (_, record) => {
                    const isB2cInvoice = record?.isB2C === true;
                    const cancelDisabled =
                      Boolean(record?.IRN) &&
                      is48HoursPassed(record?.AckDate);
                    const cancelEInvoiceBtn = (
                      <Button
                        type="primary"
                        size="small"
                        style={{
                          width: 140,
                          height: 28,
                          padding: "0 8px",
                          fontSize: 12,
                          ...(isB2cInvoice
                            ? {
                                backgroundColor: "#fff7e6",
                                borderColor: "#ffd591",
                                color: "#d46b08",
                              }
                            : {}),
                        }}
                        disabled={cancelDisabled}
                        onClick={() => openCancelInvoiceModal(record)}
                      >
                        {isB2cInvoice
                          ? "Cancel B2C Invoice"
                          : "Cancel E-Invoice"}
                      </Button>
                    );

                    return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Space direction="vertical" size={8} align="center">
                        <Button
                          type="primary"
                          icon={<DownloadOutlined />}
                          size="small"
                          style={{
                            width: 140,
                            height: 28,
                            padding: "0 8px",
                            fontSize: 12,
                            ...(isB2cInvoice
                              ? {
                                  backgroundColor: "#fff7e6",
                                  borderColor: "#ffd591",
                                  color: "#d46b08",
                                }
                              : {}),
                          }}
                          onClick={() => handleEInvoice(record._id)}
                        >
                          {isB2cInvoice ? "B2C Invoice" : "E - Invoice"}
                        </Button>

                        <Tooltip
                          title={
                            record?.isCreditNote
                              ? "Credit note already generated"
                              : "Generate Credit note"
                          }
                          placement="top"
                        >
                          {!record?.isRejected && (
                            <Button
                              type="primary"
                              size="small"
                              style={{
                                width: 140,
                                height: 28,
                                padding: "0 8px",
                                fontSize: 12,
                              }}
                              onClick={() =>
                                handleOpenCreditNoteModal(record._id)
                              }
                              disabled={
                                record?.isCreditNote || !record?.creditNoteAlert
                              }
                            >
                              {record?.isCreditNote
                                ? "Credit note generated"
                                : "Generate Credit note"}
                            </Button>
                          )}
                        </Tooltip>

                        {record?.isRejected ? (
                          <Button
                            type="primary"
                            size="small"
                            style={{
                              width: 140,
                              height: 28,
                              padding: "0 8px",
                              fontSize: 12,
                            }}
                            disabled
                          >
                            Cancelled
                          </Button>
                        ) : cancelDisabled ? (
                          <Tooltip
                            title="As 48 hours have passed since the E-invoice was generated, you need to create a credit note for this."
                            placement="top"
                          >
                            <span style={{ display: "inline-block" }}>
                              {cancelEInvoiceBtn}
                            </span>
                          </Tooltip>
                        ) : (
                          cancelEInvoiceBtn
                        )}
                      </Space>

                      {record?.creditNoteAlert && (
                        <Text
                          strong
                          style={{ color: "#ff4d4f", marginTop: 8 }}
                        >
                          Credit Amount: ₹
                          {(
                            (record?.infoForCN?.totalAmount || 0) +
                            (record?.infoForCN?.printingCharge || 0) +
                            (record?.infoForCN?.mountingCharge || 0)
                          ).toLocaleString("en-IN")}{" "}
                        </Text>
                      )}
                    </div>
                    );
                  },
                },
              ]}
            />
          )}

          {!loading && totalSubInvoices > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Pagination
                current={pageNumber}
                pageSize={pageSize}
                total={totalSubInvoices}
                onChange={handleInvPageChange}
                showSizeChanger
                pageSizeOptions={["10", "20", "50"]}
              />
            </div>
          )}
        </Space>

        {invData &&
          (console.log("Rendering GenerateSubInvoice...", invData) || (
            <GenerateSubInvoice
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              invoiceData={invData}
              eInvoice={true}
            />
          ))}

        {isCreditNoteModalOpen && creditNoteInvoiceData && (
          <CreditNote
            visible={isCreditNoteModalOpen}
            onClose={handleCloseCreditNoteModal}
            invoiceData={creditNoteInvoiceData}
            onGenerate={handleGenerateCreditNote}
          />
        )}

        <Modal
          title="Cancel Invoice"
          open={isCancelInvoiceModalVisible}
          onCancel={closeCancelInvoiceModal}
          onOk={handleConfirmCancelInvoice}
          confirmLoading={isCancellingInvoice}
          okText="Yes, Cancel"
          cancelText="No"
          okButtonProps={{
            disabled: !remark.trim() || isCancellingInvoice,
          }}
          cancelButtonProps={{
            disabled: isCancellingInvoice,
          }}
        >
          <p>Please provide a remark for cancellation:</p>
          <Input.TextArea
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            placeholder="Enter cancellation reason..."
            rows={4}
          />
          {!cancelSnapshot?.isB2C && (
            <Alert
              message="Warning"
              description="By proceeding with this cancellation, the invoice will also be cancelled from the government portal.(If generated)"
              type="info"
              showIcon
              style={{ marginBottom: "16px", marginTop: "16px" }}
            />
          )}
          {cancelSnapshot?.IRN && (
            <Card
              size="small"
              style={{
                marginTop: "16px",
                backgroundColor: "green",
                color: "white",
              }}
            >
              <p style={{ margin: 0 }}>
                E-invoice generated date and time:{" "}
                {formatAckDate(cancelSnapshot?.AckDate)}
              </p>

              {is48HoursPassed(cancelSnapshot?.AckDate) && (
                <p style={{ color: "white", marginTop: "8px" }}>
                  As 48 hours have passed since the E-invoice was generated, you
                  need to create a credit note for this, as it can no longer be
                  cancelled.
                </p>
              )}
            </Card>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default Einvoices;
